import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationContentWrapperCss,
  communicationOptionEmojiCss,
  communicationOptionLabelCss,
  communicationRootCss,
  communicationTitleCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const FeedbackQuestionPageStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div<{ $gap?: number }>`
    ${communicationContentWrapperCss}
    ${({ $gap }) => $gap !== undefined && `gap: ${$gap}px;`}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  FeedbackBlock: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  `,

  FeedbackBadge: styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 16px;
    background-color: #096ef9;
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: ${COLORS.WHITE};
    text-align: center;
  `,

  FeedbackBadgeText: styled.span`
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
  `,

  FeedbackBadgeIcon: styled.span`
    font-size: 16px;
    line-height: 1;
  `,

  FeedbackText: styled.p`
    max-width: 255px;
    margin: 0 auto;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #333b44;
  `,

  BottomGroup: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
    width: 100%;
  `,

  Options: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  OptionButton: styled.button<{ $isSelected: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 20px 16px;
    background: ${COLORS.WHITE};
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    border-radius: 16px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }
  `,

  OptionEmoji: styled.span`
    ${communicationOptionEmojiCss}
  `,

  OptionLabel: styled.span`
    ${communicationOptionLabelCss}
  `,

  Button: styled.button`
    ${communicationButtonCss}
  `,
}
